import React from 'react';
import { observer } from 'mobx-react-lite';
import { PatientCancelSessionModal } from '@uplift/ui-v2';
import { CalendarDateService } from '@uplift/services';
import { ModalsEnum, useModalsContext } from '../../hooks/modal';

type ScheduleModalsProps = {
  refetchAppointments?: () => void;
  patientId: string;
};

export const ScheduleModals = observer<ScheduleModalsProps>(({ refetchAppointments, patientId }) => {
  const modalStore = useModalsContext();
  const modalData = modalStore.getData(ModalsEnum.cancelSession);
  const fromDatetime = React.useMemo(() => {
    if (!modalData?.appointment?.fromDatetime) return null;
    return CalendarDateService.date(modalData?.appointment?.fromDatetime).utc().format();
  }, [ modalData?.appointment?.fromDatetime ]);

  if (!modalData) {
    return null;
  }
  // TODO fairly certian reschedule request is not used

  return (
    modalStore.isVisible(ModalsEnum.cancelSession) && (
      <PatientCancelSessionModal
        open
        providerName={modalData?.appointment?.providerName.first}
        appointmentId={modalData?.appointment?.id}
        fromDatetime={fromDatetime}
        cancelMode={modalData?.cancelMode}
        parentId={modalData?.appointment?.parentId}
        isMaterialized={modalData?.appointment?.isMaterialized}
        onSubmit={async () => {
          refetchAppointments?.();
        }}
        onClose={() => modalStore.closeModal(ModalsEnum.cancelSession)}
        patientId={patientId}
      />
    )
  );
});
